// src/redux/joinApi.js
import { apiSlice } from "./apiSlice";

export const joinApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        postJoin: build.mutation({
            query: (body) => ({
                url: "/api/user/join/v1",
                method: "post",
                data: body,
            }),
        }),
    }),
});

export const { usePostJoinMutation } = joinApi;
